module.exports = __webpack_public_path__ + "static/img/weather63.de011fcb.png";